// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   SETTINGS PAGE
   Matches Dashboard glassmorphism aesthetic
   ============================================ */

.settings-page {
  min-height: 100vh;
  background: var(--bg-base);
  padding: var(--space-6) var(--space-6) var(--space-16) var(--space-6);
  padding-top: 6rem;
  font-family: var(--font-primary);
  color: var(--text-primary);
}

.settings-container {
  max-width: 640px;
  margin: 0 auto;
}

/* ============================================
   SECTION LABEL — matches Dashboard domain-header
   ============================================ */

.settings-section {
  margin-bottom: var(--space-8);
}

.section-label {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
}

.section-label-text {
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: var(--tracking-widest);
  white-space: nowrap;
}

.section-label-line {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(to right, var(--border-subtle), transparent);
}

/* ============================================
   GLASS CARD
   ============================================ */

.settings-card {
  background: var(--bg-card);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-xl);
  padding: var(--space-5);
  backdrop-filter: var(--glass-blur);
  -webkit-backdrop-filter: var(--glass-blur);
}

/* ============================================
   PLAN OVERVIEW (Premium + Free)
   ============================================ */

.plan-overview {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.plan-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plan-name-group {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

/* Tier badges — match TopNav pill language */
.plan-tier-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.75rem;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  border: 1px solid;
}

.plan-tier-premium {
  background: rgba(234, 179, 8, 0.15);
  border-color: rgba(234, 179, 8, 0.3);
  color: #fbbf24;
}

.plan-tier-free {
  background: rgba(107, 114, 128, 0.15);
  border-color: rgba(107, 114, 128, 0.3);
  color: var(--text-muted);
}

/* Status dot */
.plan-status-dot {
  width: 6px;
  height: 6px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
}

.plan-status-active {
  background: var(--color-success);
  box-shadow: 0 0 6px rgba(34, 197, 94, 0.5);
}

.plan-status-text {
  font-size: var(--text-sm);
  color: var(--color-success);
  font-weight: var(--font-weight-medium);
}

/* Billing meta row */
.plan-meta {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding-top: var(--space-3);
  border-top: 1px solid var(--border-subtle);
}

.plan-meta-label {
  font-size: var(--text-xs);
  color: var(--text-subtle);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
}

.plan-meta-value {
  font-size: var(--text-base);
  color: var(--text-secondary);
  font-weight: var(--font-weight-medium);
}

/* Free plan upgrade hint */
.plan-upgrade-hint {
  font-size: var(--text-base);
  color: var(--text-muted);
  line-height: var(--leading-relaxed);
  margin: 0;
}

/* ============================================
   CARD ACTIONS
   ============================================ */

.card-actions {
  display: flex;
  gap: var(--space-3);
  padding-top: var(--space-4);
  margin-top: var(--space-2);
  border-top: 1px solid var(--border-subtle);
}

/* ============================================
   BUTTONS
   ============================================ */

.settings-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: 0.55rem 1.1rem;
  border-radius: var(--radius-lg);
  font-family: var(--font-primary);
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
}

.settings-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Primary — red accent */
.settings-btn-primary {
  background: var(--accent-primary);
  color: var(--text-primary);
}

.settings-btn-primary:hover:not(:disabled) {
  background: var(--accent-primary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

/* Secondary — ghost outline */
.settings-btn-secondary {
  background: var(--bg-surface);
  color: var(--text-secondary);
  border: 1px solid var(--border-strong);
}

.settings-btn-secondary:hover:not(:disabled) {
  background: var(--bg-surface-hover);
  border-color: var(--border-focus);
  color: var(--text-primary);
}

.settings-btn-secondary svg {
  opacity: 0.6;
}

.settings-btn-secondary:hover:not(:disabled) svg {
  opacity: 1;
}

/* Upgrade — blue, matches TopNav upgrade button */
.settings-btn-upgrade {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.settings-btn-upgrade:hover:not(:disabled) {
  background: rgba(59, 130, 246, 0.25);
  border-color: rgba(59, 130, 246, 0.5);
  color: #93c5fd;
  transform: translateY(-1px);
}

/* ============================================
   CANCELLATION BANNER
   ============================================ */

.cancellation-banner {
  background: rgba(14, 165, 233, 0.06);
  border: 1px solid rgba(14, 165, 233, 0.2);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  margin-bottom: var(--space-3);
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
}

.cancellation-banner-icon {
  color: var(--color-info);
  flex-shrink: 0;
  margin-top: 1px;
}

.cancellation-banner-content {
  flex: 1 1;
}

.cancellation-banner-content p {
  color: var(--text-secondary);
  line-height: var(--leading-relaxed);
  margin: 0 0 var(--space-3) 0;
  font-size: var(--text-base);
}

.cancellation-banner-content p strong {
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
}

/* ============================================
   ACCOUNT GRID
   ============================================ */

.account-grid {
  display: flex;
  flex-direction: column;
}

.account-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-3) 0;
}

.account-field + .account-field {
  border-top: 1px solid var(--border-subtle);
}

.account-field-label {
  font-size: var(--text-xs);
  color: var(--text-subtle);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
  font-weight: var(--font-weight-semibold);
}

.account-field-value {
  font-size: var(--text-base);
  color: var(--text-secondary);
  font-weight: var(--font-weight-medium);
}

/* ============================================
   REFERRAL CODE INPUT
   ============================================ */

.referral-field {
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: var(--space-2) !important;
}

.referral-input-group {
  display: flex;
  gap: var(--space-2);
  width: 100%;
}

.referral-input {
  flex: 1 1;
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: 0.45rem 0.75rem;
  font-size: var(--text-sm);
  font-family: var(--font-primary);
  color: var(--text-primary);
  outline: none;
  transition: border-color var(--transition-fast);
}

.referral-input::placeholder {
  color: var(--text-subtle);
}

.referral-input:focus {
  border-color: var(--border-focus);
}

.referral-input:disabled {
  opacity: 0.5;
}

.referral-btn {
  flex-shrink: 0;
  padding: 0.45rem 0.9rem !important;
  font-size: var(--text-sm) !important;
}

/* ============================================
   STUDY CLASS CARD ITEMS
   ============================================ */

.class-card-item {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.class-card-item + .class-card-item {
  padding-top: var(--space-4);
  margin-top: var(--space-3);
  border-top: 1px solid var(--border-default);
}

/* ============================================
   CANCEL CONFIRMATION MODAL
   Matches PricingModal design system
   ============================================ */

.cancel-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: clamp(1rem, 4vw, 2rem);
  overflow-y: auto;
}

.cancel-modal {
  background: #0d1117;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  width: 100%;
  max-width: 460px;
  max-height: min(88vh, 540px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cancel-modal-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.cancel-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #ffffff;
  font-family: var(--font-primary);
}

.cancel-modal-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #f87171;
  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: none;
  flex-shrink: 0;
}

.cancel-modal-close:hover {
  background: rgba(239, 68, 68, 0.25);
  border-color: rgba(239, 68, 68, 0.5);
  color: #ff6b6b;
}

.cancel-modal-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cancel-modal-close svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.cancel-modal-body {
  padding: 1.5rem;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.16) transparent;
}

.cancel-modal-body::-webkit-scrollbar {
  width: 4px;
}

.cancel-modal-body::-webkit-scrollbar-track {
  background: transparent;
}

.cancel-modal-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.16);
  border-radius: 999px;
}

.cancel-modal-body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.24);
}

.cancel-modal-body p {
  margin: 0 0 1rem 0;
  color: #d1d5db;
  font-size: 0.875rem;
  line-height: 1.6;
  font-family: var(--font-primary);
}

.cancel-modal-body p:last-child {
  margin-bottom: 0;
}

.cancel-modal-warning {
  color: #f59e0b !important;
}

.cancel-modal-warning strong {
  color: #fbbf24;
}

.cancel-modal-actions {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.25rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.cancel-modal-actions .settings-btn {
  flex: 1 1;
}

/* Danger button styling */
.settings-btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
}

.settings-btn-danger:hover:not(:disabled) {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.settings-btn-danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 768px) {
  .settings-page {
    padding: var(--space-4) var(--space-4) var(--space-16) var(--space-4);
    padding-top: 5rem;
  }

  .settings-card {
    padding: var(--space-4);
  }

  .account-field {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-1);
  }

  .cancellation-banner {
    flex-direction: column;
  }

  .card-actions {
    flex-direction: column;
  }

  .settings-btn {
    width: 100%;
  }

  .cancel-modal-actions {
    flex-direction: column;
  }

  .cancel-modal {
    max-height: min(92vh, 620px);
  }
}

@media (max-width: 480px) {
  .cancel-modal-overlay {
    padding: 0.75rem;
    align-items: flex-end;
  }

  .cancel-modal {
    max-height: min(94vh, 680px);
    border-radius: 16px;
  }

  .cancel-modal-header,
  .cancel-modal-body,
  .cancel-modal-actions {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

/* ============================================
   TUTORIAL SEGMENTS LIST
   ============================================ */

.tutorial-segments-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.tutorial-segment-row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border-subtle);
}

.tutorial-segment-row:last-child {
  border-bottom: none;
}

.tutorial-segment-status {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.tutorial-segment-status--completed { color: var(--color-success, #22c55e); }
.tutorial-segment-status--locked { color: var(--text-subtle, #64748b); opacity: 0.5; }
.tutorial-segment-status--available,
.tutorial-segment-status--in_progress { color: var(--accent-primary, #3b82f6); }

.tutorial-segment-name {
  flex: 1 1;
  font-size: var(--text-sm);
  text-transform: capitalize;
}

.tutorial-segment-progress {
  font-size: var(--text-xs);
  color: var(--text-subtle);
  font-family: var(--font-mono, monospace);
}

/* ============================================
   TUTORIAL CARD PREVIEW (Admin)
   ============================================ */

.tut-preview-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--space-3) var(--space-4);
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold, 600);
  cursor: pointer;
  font-family: var(--font-primary);
}

.tut-preview-toggle:hover {
  color: var(--text-primary);
}

.tut-preview-toggle-label {
  font-size: var(--text-sm);
}

.tut-preview-chevron {
  font-size: 0.65rem;
  transition: transform 0.15s ease;
  color: var(--text-muted);
}

.tut-preview-chevron.open {
  transform: rotate(90deg);
}

.tut-card-list {
  display: flex;
  flex-direction: column;
  padding: 0 var(--space-3) var(--space-3);
}

/* Gate group headers */
.tut-gate-header {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: var(--space-3) var(--space-2) var(--space-1);
  border-top: 2px solid var(--border-default, rgba(255,255,255,0.1));
}

.tut-gate-header:first-child {
  border-top: none;
  padding-top: var(--space-1);
}

.tut-gate-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.tut-gate-sublabel {
  font-size: 0.6rem;
  color: var(--text-subtle);
  font-family: var(--font-mono, monospace);
}

/* Card rows */
.tut-card-row {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-2);
  border-top: 1px solid var(--border-subtle);
  border-left: 3px solid transparent;
  transition: opacity 0.15s ease;
}

.tut-card-row.tut-card-seen {
  opacity: 0.4;
}

.tut-card-row.tut-card-site-action {
  border-left-color: #fbbf24;
  background: rgba(251, 191, 36, 0.03);
}

.tut-card-row.tut-card-missing {
  opacity: 0.6;
  align-items: center;
  border-left-color: #f87171;
}

.tut-card-idx {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 700;
  color: var(--text-muted);
  background: var(--bg-surface, rgba(255,255,255,0.04));
  border-radius: 50%;
  margin-top: 2px;
  font-family: var(--font-mono, monospace);
}

.tut-card-main {
  flex: 1 1;
  min-width: 0;
}

.tut-card-header {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  margin-bottom: 2px;
}

.tut-card-title {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold, 600);
  color: var(--text-primary);
}

.tut-card-id {
  font-size: 0.65rem;
  color: var(--text-subtle);
  font-family: var(--font-mono, monospace);
  white-space: nowrap;
}

.tut-card-body {
  font-size: 0.72rem;
  color: var(--text-muted);
  line-height: 1.45;
  margin: 0 0 var(--space-1) 0;
}

/* Progress method row — the main "how to advance" indicator */
.tut-card-progress-row {
  margin-bottom: var(--space-1);
}

.tut-card-progress-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: var(--font-mono, monospace);
}

.tut-progress-site-action {
  background: rgba(251, 191, 36, 0.15);
  border: 1px solid rgba(251, 191, 36, 0.35);
  color: #fbbf24;
}

.tut-progress-cta {
  background: rgba(34, 197, 94, 0.10);
  border: 1px solid rgba(34, 197, 94, 0.2);
  color: #4ade80;
}

.tut-progress-dismiss {
  background: rgba(148, 163, 184, 0.10);
  border: 1px solid rgba(148, 163, 184, 0.2);
  color: #94a3b8;
}

/* Metadata tags */
.tut-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tut-card-badge {
  font-size: 0.6rem;
  font-family: var(--font-mono, monospace);
  padding: 1px 5px;
  border-radius: 4px;
  white-space: nowrap;
  line-height: 1.5;
}

.tut-badge-spotlight {
  background: rgba(139, 92, 246, 0.12);
  border: 1px solid rgba(139, 92, 246, 0.25);
  color: #a78bfa;
}

.tut-badge-target {
  background: rgba(14, 165, 233, 0.12);
  border: 1px solid rgba(14, 165, 233, 0.25);
  color: #38bdf8;
}

.tut-badge-neutral {
  background: rgba(148, 163, 184, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.15);
  color: #94a3b8;
}

.tut-badge-warn {
  background: rgba(239, 68, 68, 0.10);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.tut-badge-error {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #f87171;
}

/* Seen/unseen checkmark */
.tut-card-check {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: var(--text-subtle);
  margin-top: 2px;
}

.tut-card-check.seen {
  color: var(--color-success, #22c55e);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,qEAAqE;EACrE,iBAAiB;EACjB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,wBAAwB;EACxB,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,wEAAwE;AAC1E;;AAEA;;iDAEiD;;AAEjD;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;EACnC,SAAS;AACX;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;iDAEiD;;AAEjD;EACE,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,uCAAuC;EACvC,+BAA+B;EAC/B,wBAAwB;EACxB,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;;;iDAGiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,SAAO;AACT;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,qEAAqE;IACrE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC,oCAAoC,EAAE;AAC5E,mCAAmC,kCAAkC,EAAE,YAAY,EAAE;AACrF;wCACwC,qCAAqC,EAAE;;AAE/E;EACE,SAAO;EACP,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,6CAA6C;EAC7C,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qDAAqD;EACrD,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,0CAA0C;EAC1C,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qDAAqD;EACrD,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* ============================================\n   SETTINGS PAGE\n   Matches Dashboard glassmorphism aesthetic\n   ============================================ */\n\n.settings-page {\n  min-height: 100vh;\n  background: var(--bg-base);\n  padding: var(--space-6) var(--space-6) var(--space-16) var(--space-6);\n  padding-top: 6rem;\n  font-family: var(--font-primary);\n  color: var(--text-primary);\n}\n\n.settings-container {\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n/* ============================================\n   SECTION LABEL — matches Dashboard domain-header\n   ============================================ */\n\n.settings-section {\n  margin-bottom: var(--space-8);\n}\n\n.section-label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  margin-bottom: var(--space-4);\n}\n\n.section-label-text {\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-widest);\n  white-space: nowrap;\n}\n\n.section-label-line {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(to right, var(--border-subtle), transparent);\n}\n\n/* ============================================\n   GLASS CARD\n   ============================================ */\n\n.settings-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-xl);\n  padding: var(--space-5);\n  backdrop-filter: var(--glass-blur);\n  -webkit-backdrop-filter: var(--glass-blur);\n}\n\n/* ============================================\n   PLAN OVERVIEW (Premium + Free)\n   ============================================ */\n\n.plan-overview {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.plan-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.plan-name-group {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n/* Tier badges — match TopNav pill language */\n.plan-tier-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.3rem 0.75rem;\n  border-radius: var(--radius-md);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--tracking-wide);\n  text-transform: uppercase;\n  border: 1px solid;\n}\n\n.plan-tier-premium {\n  background: rgba(234, 179, 8, 0.15);\n  border-color: rgba(234, 179, 8, 0.3);\n  color: #fbbf24;\n}\n\n.plan-tier-free {\n  background: rgba(107, 114, 128, 0.15);\n  border-color: rgba(107, 114, 128, 0.3);\n  color: var(--text-muted);\n}\n\n/* Status dot */\n.plan-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n}\n\n.plan-status-active {\n  background: var(--color-success);\n  box-shadow: 0 0 6px rgba(34, 197, 94, 0.5);\n}\n\n.plan-status-text {\n  font-size: var(--text-sm);\n  color: var(--color-success);\n  font-weight: var(--font-weight-medium);\n}\n\n/* Billing meta row */\n.plan-meta {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding-top: var(--space-3);\n  border-top: 1px solid var(--border-subtle);\n}\n\n.plan-meta-label {\n  font-size: var(--text-xs);\n  color: var(--text-subtle);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wide);\n}\n\n.plan-meta-value {\n  font-size: var(--text-base);\n  color: var(--text-secondary);\n  font-weight: var(--font-weight-medium);\n}\n\n/* Free plan upgrade hint */\n.plan-upgrade-hint {\n  font-size: var(--text-base);\n  color: var(--text-muted);\n  line-height: var(--leading-relaxed);\n  margin: 0;\n}\n\n/* ============================================\n   CARD ACTIONS\n   ============================================ */\n\n.card-actions {\n  display: flex;\n  gap: var(--space-3);\n  padding-top: var(--space-4);\n  margin-top: var(--space-2);\n  border-top: 1px solid var(--border-subtle);\n}\n\n/* ============================================\n   BUTTONS\n   ============================================ */\n\n.settings-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: 0.55rem 1.1rem;\n  border-radius: var(--radius-lg);\n  font-family: var(--font-primary);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n}\n\n.settings-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Primary — red accent */\n.settings-btn-primary {\n  background: var(--accent-primary);\n  color: var(--text-primary);\n}\n\n.settings-btn-primary:hover:not(:disabled) {\n  background: var(--accent-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);\n}\n\n/* Secondary — ghost outline */\n.settings-btn-secondary {\n  background: var(--bg-surface);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-strong);\n}\n\n.settings-btn-secondary:hover:not(:disabled) {\n  background: var(--bg-surface-hover);\n  border-color: var(--border-focus);\n  color: var(--text-primary);\n}\n\n.settings-btn-secondary svg {\n  opacity: 0.6;\n}\n\n.settings-btn-secondary:hover:not(:disabled) svg {\n  opacity: 1;\n}\n\n/* Upgrade — blue, matches TopNav upgrade button */\n.settings-btn-upgrade {\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.settings-btn-upgrade:hover:not(:disabled) {\n  background: rgba(59, 130, 246, 0.25);\n  border-color: rgba(59, 130, 246, 0.5);\n  color: #93c5fd;\n  transform: translateY(-1px);\n}\n\n/* ============================================\n   CANCELLATION BANNER\n   ============================================ */\n\n.cancellation-banner {\n  background: rgba(14, 165, 233, 0.06);\n  border: 1px solid rgba(14, 165, 233, 0.2);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  margin-bottom: var(--space-3);\n  display: flex;\n  gap: var(--space-3);\n  align-items: flex-start;\n}\n\n.cancellation-banner-icon {\n  color: var(--color-info);\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.cancellation-banner-content {\n  flex: 1;\n}\n\n.cancellation-banner-content p {\n  color: var(--text-secondary);\n  line-height: var(--leading-relaxed);\n  margin: 0 0 var(--space-3) 0;\n  font-size: var(--text-base);\n}\n\n.cancellation-banner-content p strong {\n  color: var(--text-primary);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* ============================================\n   ACCOUNT GRID\n   ============================================ */\n\n.account-grid {\n  display: flex;\n  flex-direction: column;\n}\n\n.account-field {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-3) 0;\n}\n\n.account-field + .account-field {\n  border-top: 1px solid var(--border-subtle);\n}\n\n.account-field-label {\n  font-size: var(--text-xs);\n  color: var(--text-subtle);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wide);\n  font-weight: var(--font-weight-semibold);\n}\n\n.account-field-value {\n  font-size: var(--text-base);\n  color: var(--text-secondary);\n  font-weight: var(--font-weight-medium);\n}\n\n/* ============================================\n   REFERRAL CODE INPUT\n   ============================================ */\n\n.referral-field {\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  gap: var(--space-2) !important;\n}\n\n.referral-input-group {\n  display: flex;\n  gap: var(--space-2);\n  width: 100%;\n}\n\n.referral-input {\n  flex: 1;\n  background: var(--bg-surface);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  padding: 0.45rem 0.75rem;\n  font-size: var(--text-sm);\n  font-family: var(--font-primary);\n  color: var(--text-primary);\n  outline: none;\n  transition: border-color var(--transition-fast);\n}\n\n.referral-input::placeholder {\n  color: var(--text-subtle);\n}\n\n.referral-input:focus {\n  border-color: var(--border-focus);\n}\n\n.referral-input:disabled {\n  opacity: 0.5;\n}\n\n.referral-btn {\n  flex-shrink: 0;\n  padding: 0.45rem 0.9rem !important;\n  font-size: var(--text-sm) !important;\n}\n\n/* ============================================\n   STUDY CLASS CARD ITEMS\n   ============================================ */\n\n.class-card-item {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.class-card-item + .class-card-item {\n  padding-top: var(--space-4);\n  margin-top: var(--space-3);\n  border-top: 1px solid var(--border-default);\n}\n\n/* ============================================\n   CANCEL CONFIRMATION MODAL\n   Matches PricingModal design system\n   ============================================ */\n\n.cancel-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: clamp(1rem, 4vw, 2rem);\n  overflow-y: auto;\n}\n\n.cancel-modal {\n  background: #0d1117;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  width: 100%;\n  max-width: 460px;\n  max-height: min(88vh, 540px);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cancel-modal-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.cancel-modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #ffffff;\n  font-family: var(--font-primary);\n}\n\n.cancel-modal-close {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #f87171;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: none;\n  flex-shrink: 0;\n}\n\n.cancel-modal-close:hover {\n  background: rgba(239, 68, 68, 0.25);\n  border-color: rgba(239, 68, 68, 0.5);\n  color: #ff6b6b;\n}\n\n.cancel-modal-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cancel-modal-close svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.cancel-modal-body {\n  padding: 1.5rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.16) transparent;\n}\n\n.cancel-modal-body::-webkit-scrollbar {\n  width: 4px;\n}\n\n.cancel-modal-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.cancel-modal-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.16);\n  border-radius: 999px;\n}\n\n.cancel-modal-body::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.cancel-modal-body p {\n  margin: 0 0 1rem 0;\n  color: #d1d5db;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  font-family: var(--font-primary);\n}\n\n.cancel-modal-body p:last-child {\n  margin-bottom: 0;\n}\n\n.cancel-modal-warning {\n  color: #f59e0b !important;\n}\n\n.cancel-modal-warning strong {\n  color: #fbbf24;\n}\n\n.cancel-modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem 1.25rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.cancel-modal-actions .settings-btn {\n  flex: 1;\n}\n\n/* Danger button styling */\n.settings-btn-danger {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n}\n\n.settings-btn-danger:hover:not(:disabled) {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n.settings-btn-danger:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n\n@media (max-width: 768px) {\n  .settings-page {\n    padding: var(--space-4) var(--space-4) var(--space-16) var(--space-4);\n    padding-top: 5rem;\n  }\n\n  .settings-card {\n    padding: var(--space-4);\n  }\n\n  .account-field {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-1);\n  }\n\n  .cancellation-banner {\n    flex-direction: column;\n  }\n\n  .card-actions {\n    flex-direction: column;\n  }\n\n  .settings-btn {\n    width: 100%;\n  }\n\n  .cancel-modal-actions {\n    flex-direction: column;\n  }\n\n  .cancel-modal {\n    max-height: min(92vh, 620px);\n  }\n}\n\n@media (max-width: 480px) {\n  .cancel-modal-overlay {\n    padding: 0.75rem;\n    align-items: flex-end;\n  }\n\n  .cancel-modal {\n    max-height: min(94vh, 680px);\n    border-radius: 16px;\n  }\n\n  .cancel-modal-header,\n  .cancel-modal-body,\n  .cancel-modal-actions {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n/* ============================================\n   TUTORIAL SEGMENTS LIST\n   ============================================ */\n\n.tutorial-segments-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.tutorial-segment-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.tutorial-segment-row:last-child {\n  border-bottom: none;\n}\n\n.tutorial-segment-status {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.tutorial-segment-status--completed { color: var(--color-success, #22c55e); }\n.tutorial-segment-status--locked { color: var(--text-subtle, #64748b); opacity: 0.5; }\n.tutorial-segment-status--available,\n.tutorial-segment-status--in_progress { color: var(--accent-primary, #3b82f6); }\n\n.tutorial-segment-name {\n  flex: 1;\n  font-size: var(--text-sm);\n  text-transform: capitalize;\n}\n\n.tutorial-segment-progress {\n  font-size: var(--text-xs);\n  color: var(--text-subtle);\n  font-family: var(--font-mono, monospace);\n}\n\n/* ============================================\n   TUTORIAL CARD PREVIEW (Admin)\n   ============================================ */\n\n.tut-preview-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold, 600);\n  cursor: pointer;\n  font-family: var(--font-primary);\n}\n\n.tut-preview-toggle:hover {\n  color: var(--text-primary);\n}\n\n.tut-preview-toggle-label {\n  font-size: var(--text-sm);\n}\n\n.tut-preview-chevron {\n  font-size: 0.65rem;\n  transition: transform 0.15s ease;\n  color: var(--text-muted);\n}\n\n.tut-preview-chevron.open {\n  transform: rotate(90deg);\n}\n\n.tut-card-list {\n  display: flex;\n  flex-direction: column;\n  padding: 0 var(--space-3) var(--space-3);\n}\n\n/* Gate group headers */\n.tut-gate-header {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: var(--space-3) var(--space-2) var(--space-1);\n  border-top: 2px solid var(--border-default, rgba(255,255,255,0.1));\n}\n\n.tut-gate-header:first-child {\n  border-top: none;\n  padding-top: var(--space-1);\n}\n\n.tut-gate-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.tut-gate-sublabel {\n  font-size: 0.6rem;\n  color: var(--text-subtle);\n  font-family: var(--font-mono, monospace);\n}\n\n/* Card rows */\n.tut-card-row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-2);\n  border-top: 1px solid var(--border-subtle);\n  border-left: 3px solid transparent;\n  transition: opacity 0.15s ease;\n}\n\n.tut-card-row.tut-card-seen {\n  opacity: 0.4;\n}\n\n.tut-card-row.tut-card-site-action {\n  border-left-color: #fbbf24;\n  background: rgba(251, 191, 36, 0.03);\n}\n\n.tut-card-row.tut-card-missing {\n  opacity: 0.6;\n  align-items: center;\n  border-left-color: #f87171;\n}\n\n.tut-card-idx {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  background: var(--bg-surface, rgba(255,255,255,0.04));\n  border-radius: 50%;\n  margin-top: 2px;\n  font-family: var(--font-mono, monospace);\n}\n\n.tut-card-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.tut-card-header {\n  display: flex;\n  align-items: baseline;\n  gap: var(--space-2);\n  margin-bottom: 2px;\n}\n\n.tut-card-title {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold, 600);\n  color: var(--text-primary);\n}\n\n.tut-card-id {\n  font-size: 0.65rem;\n  color: var(--text-subtle);\n  font-family: var(--font-mono, monospace);\n  white-space: nowrap;\n}\n\n.tut-card-body {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  line-height: 1.45;\n  margin: 0 0 var(--space-1) 0;\n}\n\n/* Progress method row — the main \"how to advance\" indicator */\n.tut-card-progress-row {\n  margin-bottom: var(--space-1);\n}\n\n.tut-card-progress-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.65rem;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: var(--font-mono, monospace);\n}\n\n.tut-progress-site-action {\n  background: rgba(251, 191, 36, 0.15);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n  color: #fbbf24;\n}\n\n.tut-progress-cta {\n  background: rgba(34, 197, 94, 0.10);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  color: #4ade80;\n}\n\n.tut-progress-dismiss {\n  background: rgba(148, 163, 184, 0.10);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  color: #94a3b8;\n}\n\n/* Metadata tags */\n.tut-card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.tut-card-badge {\n  font-size: 0.6rem;\n  font-family: var(--font-mono, monospace);\n  padding: 1px 5px;\n  border-radius: 4px;\n  white-space: nowrap;\n  line-height: 1.5;\n}\n\n.tut-badge-spotlight {\n  background: rgba(139, 92, 246, 0.12);\n  border: 1px solid rgba(139, 92, 246, 0.25);\n  color: #a78bfa;\n}\n\n.tut-badge-target {\n  background: rgba(14, 165, 233, 0.12);\n  border: 1px solid rgba(14, 165, 233, 0.25);\n  color: #38bdf8;\n}\n\n.tut-badge-neutral {\n  background: rgba(148, 163, 184, 0.08);\n  border: 1px solid rgba(148, 163, 184, 0.15);\n  color: #94a3b8;\n}\n\n.tut-badge-warn {\n  background: rgba(239, 68, 68, 0.10);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n\n.tut-badge-error {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #f87171;\n}\n\n/* Seen/unseen checkmark */\n.tut-card-check {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  color: var(--text-subtle);\n  margin-top: 2px;\n}\n\n.tut-card-check.seen {\n  color: var(--color-success, #22c55e);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
